import { render } from "./JoinFamilyGroupView.vue?vue&type=template&id=174439b4&scoped=true"
import script from "./JoinFamilyGroupView.vue?vue&type=script&lang=js"
export * from "./JoinFamilyGroupView.vue?vue&type=script&lang=js"

import "./JoinFamilyGroupView.vue?vue&type=style&index=0&id=174439b4&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174439b4"]])

export default __exports__